// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-editor {
    margin-top: 20px;
}

.add-block-container {
    position: relative;
    margin-top: 20px;
}

.add-block-btn {
    width: 100%;
    padding: 15px;
    border: 2px dashed #007bff;
    background: transparent;
    color: #007bff;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.add-block-btn:hover {
    background: #007bff;
    color: white;
    border-style: solid;
}

.add-block-btn .mdi {
    font-size: 20px;
}

.block-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 9999;
    margin-top: 10px;
}

.block-options-header {
    padding: 15px;
    border-bottom: 1px solid #eee;
    background: #f8f9fa;
    border-radius: 8px 8px 0 0;
}

.block-options-header h4 {
    margin: 0;
    font-size: 16px;
    color: #333;
}

.block-options-list {
    padding: 10px;
}

.block-option {
    padding: 12px 15px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 5px;
}

.block-option:hover {
    background: #f8f9fa;
}

.block-option:last-child {
    margin-bottom: 0;
}

.block-option .mdi {
    font-size: 18px;
    color: #007bff;
    width: 24px;
    text-align: center;
}

.block-option span:last-child {
    font-size: 14px;
    color: #333;
}

.content-blocks-list {
    margin-top: 20px;
}

.content-block-item {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    transition: all 0.3s ease;
}

.content-block-item:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.content-block-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #e9ecef;
    background: #f8f9fa;
    border-radius: 8px 8px 0 0;
}

.content-block-type {
    display: flex;
    align-items: center;
    gap: 8px;
}

.content-type-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.text-badge {
    background: #e3f2fd;
    color: #1976d2;
    border: 1px solid #bbdefb;
}

.image-badge {
    background: #e8f5e8;
    color: #388e3c;
    border: 1px solid #c3e6cb;
}

.quote-badge {
    background: #e1f5fe;
    color: #0d47a1;
    border: 1px solid #b3e5fc;
}

.content-block-actions {
    display: flex;
    gap: 5px;
}

.action-btn {
    width: 32px;
    height: 32px;
    border: 1px solid #dee2e6;
    background: white;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
}

.action-btn:hover:not(:disabled) {
    background: #f8f9fa;
    border-color: #adb5bd;
}

.action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.delete-btn:hover:not(:disabled) {
    background: #ffebee;
    border-color: #f8bbd9;
    color: #c62828;
}

.action-btn .mdi {
    font-size: 14px;
}

.content-block-content {
    padding: 20px;
}

.text-block-content {
    display: flex;
    flex-direction: column;
}

.quote-block-content {
    display: flex;
    flex-direction: column;
}

.image-block-content {
    display: flex;
    flex-direction: column;
}

.content-textarea {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 12px;
    font-size: 14px;
    line-height: 1.5;
    resize: vertical;
    transition: border-color 0.2s ease;
    font-family: inherit;
}

.content-textarea:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.quote-textarea {
    font-style: italic;
    background: #f8f9fa;
}

.quote-icon {
    color: #6c757d;
    margin-bottom: 10px;
    font-size: 18px;
}

.image-placeholder {
    border: 2px dashed #dee2e6;
    border-radius: 8px;
    padding: 30px;
    text-align: center;
    background: #f8f9fa;
}

.image-icon {
    color: #6c757d;
    margin-bottom: 15px;
    font-size: 48px;
}

.image-placeholder p {
    margin: 0;
    color: #6c757d;
    font-size: 14px;
}

.rich-text-editor-container {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.editor-toolbar {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    border-radius: 8px 8px 0 0;
    gap: 8px;
    flex-wrap: wrap;
}

.toolbar-group {
    display: flex;
    align-items: center;
    gap: 4px;
}

.toolbar-divider {
    width: 1px;
    height: 24px;
    background: #dee2e6;
    margin: 0 8px;
}

.toolbar-btn {
    width: 32px;
    height: 32px;
    border: 1px solid transparent;
    background: transparent;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #495057;
    font-size: 14px;
}

.toolbar-btn:hover {
    background: #e9ecef;
    border-color: #dee2e6;
    color: #007bff;
}

.toolbar-btn:active {
    background: #dee2e6;
    color: #007bff;
}

.editor-content {
    padding: 20px;
    min-height: 300px;
}

.rich-text-editor {
    width: 100%;
    min-height: 300px;
    padding: 16px;
    border: none;
    outline: none;
    font-size: 16px;
    line-height: 1.6;
    color: #333;
    background: transparent;
    resize: vertical;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.rich-text-editor:focus {
    outline: none;
}

.rich-text-editor:empty:before {
    content: attr(placeholder);
    color: #adb5bd;
    font-style: italic;
    pointer-events: none;
}

.rich-text-editor h1,
.rich-text-editor h2,
.rich-text-editor h3,
.rich-text-editor h4,
.rich-text-editor h5,
.rich-text-editor h6 {
    margin: 16px 0 8px 0;
    font-weight: 600;
}

.rich-text-editor p {
    margin: 8px 0;
}

.rich-text-editor ul,
.rich-text-editor ol {
    margin: 8px 0;
    padding-left: 24px;
}

.rich-text-editor li {
    margin: 4px 0;
}

.rich-text-editor blockquote {
    margin: 12px 0;
    padding-left: 16px;
    border-left: 4px solid #007bff;
    font-style: italic;
    color: #6c757d;
}

.rich-text-editor a {
    color: #007bff;
    text-decoration: underline;
}

.rich-text-editor strong {
    font-weight: 600;
}

.rich-text-editor em {
    font-style: italic;
}

.rich-text-editor u {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Blog/BlogAdd/BlogContentEditor.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;IACtC,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,0BAA0B;IAC1B,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,8EAA8E;AAClF;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;;;;;IAMI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".content-editor {\n    margin-top: 20px;\n}\n\n.add-block-container {\n    position: relative;\n    margin-top: 20px;\n}\n\n.add-block-btn {\n    width: 100%;\n    padding: 15px;\n    border: 2px dashed #007bff;\n    background: transparent;\n    color: #007bff;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.add-block-btn:hover {\n    background: #007bff;\n    color: white;\n    border-style: solid;\n}\n\n.add-block-btn .mdi {\n    font-size: 20px;\n}\n\n.block-options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n    z-index: 9999;\n    margin-top: 10px;\n}\n\n.block-options-header {\n    padding: 15px;\n    border-bottom: 1px solid #eee;\n    background: #f8f9fa;\n    border-radius: 8px 8px 0 0;\n}\n\n.block-options-header h4 {\n    margin: 0;\n    font-size: 16px;\n    color: #333;\n}\n\n.block-options-list {\n    padding: 10px;\n}\n\n.block-option {\n    padding: 12px 15px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 5px;\n}\n\n.block-option:hover {\n    background: #f8f9fa;\n}\n\n.block-option:last-child {\n    margin-bottom: 0;\n}\n\n.block-option .mdi {\n    font-size: 18px;\n    color: #007bff;\n    width: 24px;\n    text-align: center;\n}\n\n.block-option span:last-child {\n    font-size: 14px;\n    color: #333;\n}\n\n.content-blocks-list {\n    margin-top: 20px;\n}\n\n.content-block-item {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n    transition: all 0.3s ease;\n}\n\n.content-block-item:hover {\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n.content-block-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 20px;\n    border-bottom: 1px solid #e9ecef;\n    background: #f8f9fa;\n    border-radius: 8px 8px 0 0;\n}\n\n.content-block-type {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.content-type-badge {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.text-badge {\n    background: #e3f2fd;\n    color: #1976d2;\n    border: 1px solid #bbdefb;\n}\n\n.image-badge {\n    background: #e8f5e8;\n    color: #388e3c;\n    border: 1px solid #c3e6cb;\n}\n\n.quote-badge {\n    background: #e1f5fe;\n    color: #0d47a1;\n    border: 1px solid #b3e5fc;\n}\n\n.content-block-actions {\n    display: flex;\n    gap: 5px;\n}\n\n.action-btn {\n    width: 32px;\n    height: 32px;\n    border: 1px solid #dee2e6;\n    background: white;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 14px;\n}\n\n.action-btn:hover:not(:disabled) {\n    background: #f8f9fa;\n    border-color: #adb5bd;\n}\n\n.action-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.delete-btn:hover:not(:disabled) {\n    background: #ffebee;\n    border-color: #f8bbd9;\n    color: #c62828;\n}\n\n.action-btn .mdi {\n    font-size: 14px;\n}\n\n.content-block-content {\n    padding: 20px;\n}\n\n.text-block-content {\n    display: flex;\n    flex-direction: column;\n}\n\n.quote-block-content {\n    display: flex;\n    flex-direction: column;\n}\n\n.image-block-content {\n    display: flex;\n    flex-direction: column;\n}\n\n.content-textarea {\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    padding: 12px;\n    font-size: 14px;\n    line-height: 1.5;\n    resize: vertical;\n    transition: border-color 0.2s ease;\n    font-family: inherit;\n}\n\n.content-textarea:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.quote-textarea {\n    font-style: italic;\n    background: #f8f9fa;\n}\n\n.quote-icon {\n    color: #6c757d;\n    margin-bottom: 10px;\n    font-size: 18px;\n}\n\n.image-placeholder {\n    border: 2px dashed #dee2e6;\n    border-radius: 8px;\n    padding: 30px;\n    text-align: center;\n    background: #f8f9fa;\n}\n\n.image-icon {\n    color: #6c757d;\n    margin-bottom: 15px;\n    font-size: 48px;\n}\n\n.image-placeholder p {\n    margin: 0;\n    color: #6c757d;\n    font-size: 14px;\n}\n\n.rich-text-editor-container {\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    background: white;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.editor-toolbar {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    background: #f8f9fa;\n    border-bottom: 1px solid #e9ecef;\n    border-radius: 8px 8px 0 0;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.toolbar-group {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.toolbar-divider {\n    width: 1px;\n    height: 24px;\n    background: #dee2e6;\n    margin: 0 8px;\n}\n\n.toolbar-btn {\n    width: 32px;\n    height: 32px;\n    border: 1px solid transparent;\n    background: transparent;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: #495057;\n    font-size: 14px;\n}\n\n.toolbar-btn:hover {\n    background: #e9ecef;\n    border-color: #dee2e6;\n    color: #007bff;\n}\n\n.toolbar-btn:active {\n    background: #dee2e6;\n    color: #007bff;\n}\n\n.editor-content {\n    padding: 20px;\n    min-height: 300px;\n}\n\n.rich-text-editor {\n    width: 100%;\n    min-height: 300px;\n    padding: 16px;\n    border: none;\n    outline: none;\n    font-size: 16px;\n    line-height: 1.6;\n    color: #333;\n    background: transparent;\n    resize: vertical;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.rich-text-editor:focus {\n    outline: none;\n}\n\n.rich-text-editor:empty:before {\n    content: attr(placeholder);\n    color: #adb5bd;\n    font-style: italic;\n    pointer-events: none;\n}\n\n.rich-text-editor h1,\n.rich-text-editor h2,\n.rich-text-editor h3,\n.rich-text-editor h4,\n.rich-text-editor h5,\n.rich-text-editor h6 {\n    margin: 16px 0 8px 0;\n    font-weight: 600;\n}\n\n.rich-text-editor p {\n    margin: 8px 0;\n}\n\n.rich-text-editor ul,\n.rich-text-editor ol {\n    margin: 8px 0;\n    padding-left: 24px;\n}\n\n.rich-text-editor li {\n    margin: 4px 0;\n}\n\n.rich-text-editor blockquote {\n    margin: 12px 0;\n    padding-left: 16px;\n    border-left: 4px solid #007bff;\n    font-style: italic;\n    color: #6c757d;\n}\n\n.rich-text-editor a {\n    color: #007bff;\n    text-decoration: underline;\n}\n\n.rich-text-editor strong {\n    font-weight: 600;\n}\n\n.rich-text-editor em {\n    font-style: italic;\n}\n\n.rich-text-editor u {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
